import { ThemePackage } from '../types/theme';

export class ThemeMaterial implements ThemePackage {
  defaultRowSize = 42;
}
